module.exports = __webpack_public_path__ + "media/images/capslock-f2e148ed477742873680b9c96fd6e44e.png";